import type { SVGProps } from '@integrations/react'
import { uiSize } from '@utils'

interface Props extends Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> {
  /** Rendered width and height in px; `null` leaves sizing to the host's CSS. */
  size?: number | null
}

function CalendarIcon({ size = 13, strokeWidth = 2, ...props }: Props) {
  return (
    <svg
      width={uiSize(size)}
      height={uiSize(size)}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={strokeWidth}
      aria-hidden='true'
      {...props}
    >
      <rect x='3' y='5' width='18' height='16' rx='2' />
      <path d='M3 10h18M8 3v4M16 3v4' />
    </svg>
  )
}

export default CalendarIcon
